export const CUSTOMER_DETAILS_PROMPT = "How do you want to collect the customer's information?";
export const CUSTOMER_DETAILS_OTHER_WAYS_LABEL = 'Other ways to collect';

export const CUSTOMER_DETAILS_LABELS = {
    title: (buyerName: string, coBuyerFirstName?: string) =>
        coBuyerFirstName ? `${buyerName} & ${coBuyerFirstName}'s Details` : `${buyerName}'s Details`,
    prompt: CUSTOMER_DETAILS_PROMPT,
    otherWaysLabel: CUSTOMER_DETAILS_OTHER_WAYS_LABEL
};
